<template>
  <div class="waf-component roi-component waf-schedule">
    <div class="content-wrap" v-if="has_store_data">
      <Breadcrumbs
        :parentRoute="parentRoute"
        :sequence="[
          {type: 'base', page: 'home'},
          {type: 'module', module: parentRoute}
        ]"
      />
      <div class="waf-head">
        <h1 class="title">{{ translations.scheduleHeading }}</h1>
      </div>
      <!-- <div class="page_desc">
        <p>{{getPageDesc()}}</p>
      </div> -->
      <div class="sports-tabs mt-5">
        <!-- <div class="sports-tabs-wrap">
          <ul class="tabs">
            <li
              v-for="(s, idx) in sportList"
              v-bind:key="idx"
              :class="[
                sportDetails[s].className,
                'no-select',
                { active: selected_sport === s },
                { 'btn-disabled': show_schedule_loader },
              ]"
              @click="changeSport(s)"
            >
              <a>
                <span class="txt">{{ sportDetails[s].name }}</span>
              </a>
            </li>
          </ul>
        </div> -->
      </div>
      <!-- <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" /> -->
      <!-- <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" /> -->
      <div class="waf-body">
        <div class="fg-preloader-wrap" v-if="show_schedule_loader">
          <div class="fg-preloader active"></div>
        </div>
        <series-list-box :seriesList="seriesList" v-else-if="seriesList && seriesList.length" />
        <no-list
          v-else
          :translations="translations"
          :toShow="'no_series'"
        />
      </div>
      <pagination
        v-if="totalCount > 0"
        :currentPage="page_number"
        :recordsPerView="pagesize"
        :totalRecords="totalCount"
        :baseUrl="getPaginationBaseUrl()"
        :isLoadMoreDisabled="isLoadMoreDisabled"
        :onPageChange="onPageChange"
      />
    </div>
  </div>
</template>
<script>
import { addPagePropertiesToObject, cssImport, sendTrackingData } from '../../assets/js/common';
import { CFG_MODULES, CFG_TRACKING } from "../../assets/js/config";
import SeriesListBox from "./SeriesListBox";
import NoList from "../common/NoList";
import scheduleModule from "../../store/modules/schedule/schedule";
import Breadcrumbs from "../common/Breadcrumbs";
import Pagination from "../common/Pagination";
// import GamezyAd from '../common/GamezyAd';
export default {
  components: {
    NoList,
    SeriesListBox,
    Breadcrumbs,
    Pagination,
    // GamezyAd
  },
  data() {
    return {
      componentPromises: null,
      parentRoute: CFG_MODULES.SCHEDULE.route,
      loaded_module: CFG_MODULES.SCHEDULE.name,
    };
  },
  computed: {
    has_store_data() {
      return !!(this.$store.state && this.$store.state.schedule && this.$store.state.schedule.store_schedule_filled);
    },
    sportList() {
      return this.$store.state.schedule.sportList;
    },
    sportDetails() {
      return this.$store.state.schedule.sportDetails;
    },
    translations() {
      return this.$store.state.translations;
    },
    selected_sport: {
      get: function () {
        return this.$store.state.schedule.selected_sport;
      },
      set: function (sport_id) {
        this.$store.state.schedule.selected_sport = sport_id;
      },
    },
    show_schedule_loader() {
      return this.$store.state.schedule.show_loader;
    },
    seriesList: {
      get: function () {
        return this.$store.state.schedule.seriesList;
      },
      set: function (newList) {
        this.$store.state.schedule.seriesList = newList;
      }
    },
    page_number: {
      get: function () {
        return this.$store.state.schedule.pagenumber;
      },
      set: function (newPage) {
        this.$store.state.schedule.pagenumber = newPage;
      },
    },
    totalCount() {
      return this.$store.state.schedule.totalCount;
    },
    pagesize() {
      return this.$store.state.schedule.pagesize;
    },
    isLoadMoreDisabled() {
      return this.$store.state.schedule.isLoadMoreDisabled;
    }
    /**shared state end */
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("schedule", scheduleModule);
    return await this.$store.dispatch("schedule/fetchSeriesListing");
  },
  beforeMount() {
    this.registerScheduleModule();
  },
  mounted() {
    let hasStore = this.has_store_data;
    if (!hasStore) {
      cssImport([
        "/static-assets/css/fg-top-widget.css",
        "/static-assets/css/schedule.css"
      ])
      this.initApis();
    }
  },
  methods: {
    async registerScheduleModule() {
      let hasScheduleModule = this.$store.hasModule("schedule");
      if (!hasScheduleModule) {
        this.$store.registerModule("schedule", scheduleModule, {
          preserveState: this.has_store_data,
        });
      }
    },
    async initApis() {
      return this.$store.dispatch("schedule/fetchSeriesListing")
    },
    changeSport(sport_id) {
      if (this.show_schedule_loader || this.selected_sport === sport_id)
        return false;
      this.selected_sport = sport_id;
      this.seriesList = []; // clearing listin before apiCall
      this.$store.dispatch("schedule/fetchSeriesListing")
    },
    getPaginationBaseUrl() {
      if (CFG_MODULES.SCHEDULE) {
        let hiUrl = this.$route && this.$route.path && this.$route.path.includes("/hi/") ? "/hi" : "";
        let baseRoute = CFG_MODULES.SCHEDULE.route;
        let sportPath = (this.$route && this.$route.params && this.$route.params.sport_name) || "";
        let sportRoute = sportPath ? `${sportPath}/` : "";
        return `${hiUrl}${baseRoute}${sportRoute}page/`;
      }
    },
    onPageChange(pageNum) {
      if (CFG_MODULES.SCHEDULE) {
        let basePaginationUrl = this.getPaginationBaseUrl();
        let redirectionUrl = `${basePaginationUrl}${pageNum}`;
        if (pageNum == 1) {
          redirectionUrl = redirectionUrl.replace(`/page/${pageNum}`, "");
        }
        this.page_number = pageNum;

        // let sportPath = (this.$route && this.$route.params && this.$route.params.sport_name) || "";
        this.$router.push({ path: redirectionUrl }, () => {
          let toTrack = CFG_TRACKING["22"];
          toTrack.value = this.page_number;
          toTrack.label = `schedule_page_${this.page_number}`;
          toTrack = addPagePropertiesToObject(toTrack);
          sendTrackingData(toTrack);

          window.scrollTo({ top: 0, behavior: "smooth" });
          this.$store.dispatch("schedule/fetchSeriesListing");
        });
      }
    },
    getPageDesc() {
      let sportName = this.sportDetails[this.selected_sport].name;
      let desc = this.translations.scheduleDesc.replace(/{{sportName}}/g, sportName);
      return desc;
    }
  },
  beforeDestroy() {
    // reset schedule data
  },
  unmounted() {
    let hasScheduleStore = this.$store.hasModule("schedule");
    if(hasScheduleStore){
      this.$store.unregisterModule("schedule");
    }
  },
};
</script>


